<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Cajones</v-toolbar-title>
      <br />
      <template v-if="$store.getters.usuario.idRol == 5">
        <v-autocomplete
          v-model="contratistaSeleccionado"
          :items="listaContratistas"
          item-value="idContratista"
          item-text="descripcionContratista"
          required
          attach
          prepend-icon="mdi-truck"
          label="Contratista"
          no-data-text="No se encontraron contratistas"
          hint="Seleccione la contratista para ver sus materiales"
          persistent-hint
          @change="cambioContratista"
        ></v-autocomplete>
      </template>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar Cajon por Id / Cajon / Descripciòn"
        dense
      ></v-text-field>
    </v-col>
    <v-data-table
      :headers="headers"
      :items="cajones"
      item-key="idCajon"
      sort-by="idCajon"
      :search="buscar"
      :header-props="headerProps"
      :footer-props="footerProps"
      no-data-text="No se encontraron registros"
      no-results-text="No se encontraron registros en la búsqueda"
    >
      <template v-slot:[`item.idCuadrilla`]="{ item }">
        {{ getTextoCuadrilla(item.idCuadrilla) }}
      </template>

      <template v-slot:[`item.estado`]="{ item }">
        <v-chip :color="getColor(item.estado)">
          {{ getTextoEstado(item.estado) }}
        </v-chip>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="indigo"
                dark
                class="mx-2"
                @click="AbrirModal(0)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Armar Cajon</span>
          </v-tooltip>

          <!-- <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="red"
                dark
                class="mx-2"
                @click="ingresarRemitoDevolucion(58)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Cerrar Cajon</span>
          </v-tooltip> -->

          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Está seguro que desea eliminar esta Cajon?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip left color="red">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="red"
              dark
              class="mx-2"
              @click="cerrarCajon(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Cerrar Cajon</span>
        </v-tooltip>
        <v-tooltip left color="blue">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="blue"
              dark
              class="mx-2"
              @click="verDetalleCajon(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-eye </v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>
        <!--
        <v-tooltip left color="orange">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="orange"
              dark
              class="mx-2"
              @click="imprimirCajon(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir Cajon</span>
        </v-tooltip>
        -->

        <template v-if="item.idCuadrilla == 0">
          <!-- <v-tooltip left color="green">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="green"
                dark
                class="mx-2"
                @click="AbrirModalModificacion(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Modificar Cajon</span>
          </v-tooltip> -->
        </template>
      </template>
    </v-data-table>

    <insertCajon
      ref="insertCajon"
      @recargarListado="recargarListado"
    ></insertCajon>
    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
    <!-- <dialog-mensaje
      ref="dialogMensaje"
      @resultado="confirmarCierreCajon"
    /> -->
  </v-col>
</template>
<script>
//import dialogMensaje from "@/components/modalMensaje.vue";
import insertCajon from "@/modulos/Cajones/componentes/modalCajones.vue";
import dialogMensaje from "@/components/modalMensaje.vue";
//import insertCajon from "@/modulos/Materiales/componentes/modalMateriales.vue";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
export default {
  components: {
    insertCajon,
    dialogMensaje,
  },
  data: () => ({
    idOTTitulo: "",
    listaContratistas: [],
    contratistaSeleccionado: "",
    idCajonEliminar: "",
    tipoConsulta: "",
    idCuadrillaEliminar: "",
    dialogDelete: false,
    cajones: [],
    headers: [
      // {
      //   text: "Id",
      //   align: "start",
      //   sortable: true,
      //   value: "idCajon",
      //   class: "black white--text",
      // },
      { text: "IdCajon", value: "idCajon", class: "black white--text" },
      { text: "Cuadrilla", value: "idCuadrilla", class: "black white--text" },
      { text: "OT", value: "idOT", class: "black white--text" },
      {
        text: "Fecha de Asignacion",
        value: "fechaCreacion",
        class: "black white--text",
      },
      { text: "Estado", value: "estado", class: "black white--text" },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    buscar: "",
    cuadrillas: [],
    editedIndex: -1,
    editedItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
    defaultItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    // Mostrar los datos en la consola
    //this.getListarCuadrillaByCajon();
    //this.getListarOTCajones();
    if (this.$store.getters.usuario.idRol == 5) {
      await this.getListarContratistas();
      this.reiniciarIdContratista();
    } else {
      await this.getListarCajonesByContratista();
      console.log("Antes de las bobinas");
      await this.getListarMaterialesContratista();
      await this.getBobinas();
      //await this.getDetallesMaterialesBobina();
    }
  },
  methods: {
    async getListarMaterialesContratista() {
      this.url =
        `${this.$store.state.urlBase}Material/recuperarMaterialesContratista` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material es:");
        console.log(respuesta.data);
        this.Materiales = respuesta.data;
        this.idOTTitulo = respuesta.data[0].idOT;
      } else {
        console.log("Error");
      }
    },

    async getBobinas() {
      if (this.$store.getters.usuario.idRol === 3) {
        this.url =
          this.$store.getters.urlBase +
          "Bobina/recuperarBobinas?idOT=" +
          this.idOTTitulo;
      }

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales bobina");
          console.log(response.data);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.listaBobinas = respuesta;

      this.listaBobinas.forEach((bobina) => {
        if (bobina.secInicio === 0 && bobina.secFin === 0) {
          console.log(bobina);
          this.$router.push({
            name: "bobinas",
            params: {
              datos: this.listaBobinas,
              idOT: this.idOTTitulo,
            },
          });
          //this.$refs.abrirModalInsert_Update.openModal(tipo);
        }
      });
    },

    reiniciarIdContratista() {
      this.$store.getters.usuario.idContratista = 0;
    },

    async imprimirCajon(cajon) {
      var materiales = await this.getDetallesCajon(cajon.idCajon);

      console.log("El cajon es");
      console.log(cajon);

      console.log("Los materiales son");
      console.log(materiales);

      const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        //format: [4, 2],
        format: "A4",
        margin: { top: 20 },
      });

      const lineaInicial = 70;

      //const lineaInicialSombreado = 80;

      const encabezado = ["Matricula", "Descripcion", "Cantidad"];

      const espacioEntreLineas = 20;

      const titulo = "Listado de Materiales";

      const idCajon = "ID Cajon: " + cajon.idCajon;

      const idCuadrilla = "Cuadrilla: " + cajon.idCuadrilla;

      const fechaAsignacion = "Fecha Asignacion: " + cajon.fechaCreacion;

      //const idturno = "NRO OT: " + turno.idTurno;

      // console.log(titulo);
      // console.log(idturno);
      // console.log(ticket);
      // console.log(fechaTicket);
      // console.log(nroVale);
      // console.log(doc);

      //      const logo = require("../../assets/Logo_edese_hd(2).png");

      //     var imgLogo = new Image();
      //     imgLogo.src = logo;
      //     doc.addImage(imgLogo, "PNG", 0, 0, 200, 80);

      doc.text(titulo, doc.internal.pageSize.width * 0.63, 37, {
        aling: "right",
      });

      doc.text(
        idCajon,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 2,
        {
          aling: "right",
        }
      );

      doc.text(
        idCuadrilla,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 3,
        {
          aling: "right",
        }
      );

      doc.text(
        fechaAsignacion,
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 4,
        {
          aling: "right",
        }
      );

      // doc.text(
      //   almacen,
      //   doc.internal.pageSize.width * 0.05,
      //   lineaInicial + espacioEntreLineas * 5,
      //   {
      //     aling: "right",
      //   }
      // );

      const arregloDatos = Object(materiales).map(function (obj) {
        const datos = [obj.idMaterial, obj.nombre, obj.cantidadInicial];
        return datos;
      });

      autoTable(doc, {
        head: [encabezado],
        body: arregloDatos,
        margin: { top: 200 },
      });

      const logo = require("../../assets/Logo_edese_hd(2).png");

      var imgLogo = new Image();
      imgLogo.src = logo;
      doc.addImage(imgLogo, "PNG", 0, 0, 200, 80);

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.05,
        lineaInicial + espacioEntreLineas * 25,
        {
          aling: "right",
        }
      );

      doc.text(
        "Firma Cuadrilla",
        doc.internal.pageSize.width * 0.12,
        lineaInicial + espacioEntreLineas * 26.5,
        {
          aling: "right",
        }
      );

      doc.text(
        "----------------------------------",
        doc.internal.pageSize.width * 0.6,
        lineaInicial + espacioEntreLineas * 25,
        {
          aling: "left",
        }
      );

      doc.text(
        "Firma Enc. Depósito Contratista",
        doc.internal.pageSize.width * 0.56,
        doc.internal.pageSize.height * 0.95,
        {
          aling: "left",
        }
      );

      const hoy = new Date();
      doc.save(
        hoy.getDate() +
          hoy.getMonth() +
          hoy.getFullYear() +
          hoy.getTime() +
          ".pdf"
      );
    },
    async asignarCajonModel(cajonSeleccionado) {
      this.$refs.insertCajon.asignarCajonOpen(cajonSeleccionado);
    },

    async getListarContratistas() {
      console.log("Ingreso en listar contratistas");
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      //var listacontratistas = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.listaContratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    recargarListado() {
      this.getListarCajonesByContratista();
    },

    cerrarCajon(item) {
      console.log("Los datos para cerrar el cajon es: ");
      console.log(item.idCajon);
      this.tipoConsulta = 3;
      this.idCajonEliminar = item.idCajon;
      this.idCuadrillaEliminar = item.idCuadrilla;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Esta por cerrar el Cajon N° " + item.idCajon + ", desea continuar?",
        2,
        "red",
        "Confirmacion"
      );
    },

    async confirmarOperacion(resultadoFinal) {
      console.log("Esto hay en el resultado final");
      console.log(resultadoFinal);
      console.log("El tipo de consulta es: ");
      console.log(this.tipoConsulta);

      var obj;

      if (resultadoFinal == true) {
        if (this.tipoConsulta == 3) {
          // this.url =
          //   this.$store.state.urlBase + "Cajon/cerrarCajon?idCajon=";
          // this.idCajonEliminar;
          this.url = this.$store.state.urlBase + "Cajon/cerrarCajon";

          obj = {
            idCuadrilla: this.idCuadrillaEliminar,
            idCajon: this.idCajonEliminar,
            idUsuario: this.$store.getters.usuario.user_id,
            idContratista: this.$store.getters.usuario.idContratista,
          };

          console.log("Esto hay en el obj de cerrar cajon");
          console.log(obj);
        }

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
            //await this.ingresarRemitoDevolucion(this.idCajonEliminar);
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        // if (this.bandera == 1) {
        //   console.log("Ingresoe en la bandera 1 para ocultar el dialog");
        //   this.dialogForm = false;
        // }
        // if (this.tipoConsulta == 3) {
        //   await this.ingresarRemitoDevolucion(this.idCajonEliminar);
        // }

        this.recargarListado();
      }
    },

    async ingresarRemitoDevolucion(idCajon) {
      this.url =
        this.$store.getters.urlBase + "Remito/ingresarRemitoDevolucion";

      const remito = {
        idCajon: idCajon,
        idUsuario: this.$store.getters.usuario.user_id,
        idContratista: this.$store.getters.usuario.idContratista,
      };

      // var params = {
      //   remito: remito,
      // };

      console.log("Los parametros son:");
      console.log(remito);

      axios.post(this.url, remito).then((response) => {
        console.log("Las respuesta de ingresa remito devolucion es: ");
        console.log(response.data);
        if (response.data == false) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ya existe un remito con el mismo numero",
            1,
            "red",
            "Aviso"
          );
        } else {
          this.$refs.dialogCuadrilla.abrirCuadrillaDialog(
            "Operacion Exitosa",
            1,
            "green",
            "Ok"
          );
        }
        this.otMantenimiento = response.data;
      });
    },

    getColor(estado) {
      console.log("Ingreso en la funcion getCOlor");
      if (estado == 1) return "green";
      else if (estado == 0) return "red";
    },

    getTextoCuadrilla(idCuadrilla) {
      return idCuadrilla === 0 ? "Sin Asignar" : idCuadrilla;
    },

    getTextoEstado(estado) {
      return estado === 1 ? "Activo" : "Inactivo";
    },

    async getListarOTCajones() {
      this.url = this.$store.getters.urlBase + "OT/recuperarOTsCajon";

      var listaCajon = [];
      this.cajones = listaCajon;

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperarOTsCajon");
          console.log(response.data);
          this.cajones = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async confirmarCierreCuadrilla(resultadoFinal) {
      //console.log("Ingreso en confirmar cierre ");
      if (resultadoFinal == true) {
        //console.log("Ingreso en el true del confirmar cierre");
        this.url = this.$store.getters.urlBase + "Cuadrilla/cerrarCuadrilla";

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var obj = {
          idCuadrilla: this.idCuadrillaEliminar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        console.log("La direccion es: ");
        console.log(this.url);

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        if (this.bandera == 1) {
          console.log("Ingresoe en la bandera 1 para ocultar el dialog");
          this.dialogForm = false;
        }

        this.$router.push("/Cuadrillas");
      }
    },

    verDetalleCajon(datos) {
      console.log("Ingreso en ver detalle");
      console.log(datos);
      this.$refs.insertCajon.abrirModalCajones(datos);
      //this.$refs.insertCajon.openModal(datos);
    },

    async getDetallesCajon(idCajon) {
      console.log("Ingreso en los detalles del cajon");
      this.url =
        this.$store.getters.urlBase +
        "Cajon/recuperarCajonMateriales?idCajon=" +
        idCajon;

      this.listaMaterialesCajon = [];
      this.listaMaterialesOriginales = [];
      //this.cajones = listaCajon;
      console.log(this.url);
      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperar materiales cajon");
          console.log(response.data);
          this.listaMaterialesCajon = response.data;
          console.log(this.listaMaterialesCajon);
          return response.data;
          //this.tablaMaterialesCajonModificacion = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      // this.tablaMaterialesCajonModificacion = respuesta;
      // this.listaMaterialesCajon = respuesta;
      // this.loadingButton = false;
      // respuesta.forEach((material) => {
      //   this.listaMaterialesOriginales.push({
      //     idMaterial: material.idMaterial,
      //     cantidad: material.cantidadSaldo,
      //   });
      // });

      // console.log("Lo que hay en la tabla Materiales para la modificacion es");
      // console.log(this.tablaMaterialesCajonModificacion);

      // console.log("Los materiales originales son: ");
      // console.log(this.listaMaterialesOriginales);

      return respuesta;

      //this.getDetallesCuadrilla();
    },

    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Cuadrilla",
        params: { datos },
      });
    },
    AbrirModal() {
      console.log("Presiono abrir el modal");
      console.log(this.$store.getters.usuario.idContratista);
      // this.$refs.abrirModalCajon.openModal();
      if (
        this.$store.getters.usuario.idContratista == 0 ||
        this.$store.getters.usuario.idContratista == null
      ) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Debe seleccionar un Contratista para poder armar un cajon",
          1,
          "red",
          "Aviso"
        );
      } else {
        this.$router.push({
          name: "ArmarCajon",
        });
      }
    },
    AbrirModalModificacion(datos) {
      this.$refs.insertCajon.abrirModalModificarCajon(datos);
      //this.$refs.abrirModalCajon.(item);
    },
    deleteItem(item) {
      this.editedIndex = this.cuadrillas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.cuadrillas.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cerrarCuadrilla(datosCuadrilla) {
      this.idCuadrillaEliminar = datosCuadrilla.idCuadrilla;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea cerrar la cuadrilla " + datosCuadrilla.idCuadrilla + " ?",
        2,
        "red",
        "Aviso"
      );
    },

    async getListarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    cambioContratista() {
      console.log("El contratista es: ");
      console.log(this.contratistaSeleccionado);
      this.$store.getters.usuario.idContratista = this.contratistaSeleccionado;
      this.getListarCajonesByContratista();
    },

    async getListarCajonesByContratista() {
      this.url =
        `${this.$store.state.urlBase}Cajon/recuperarCajonesContratista` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      //this.url = this.$store.getters.urlBase + "";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idCajon:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.cajoneseleccion
        //       : this.$store.getters.idCajon,
        // },
        url: this.url,
      };

      // var obj = {
      //   idContratista: idContratista,
      //   idDistrito: this.$store.getters.usuario.idDistrito,
      // };

      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cajones es:");
        console.log(respuesta.data);
        this.cajones = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
